import { createContext, useContext } from "react";
import type {
  PublicQuoteLine,
  PublicQuoteQuantityBreak,
  PublicQuoteSectionLine,
} from "@forgepoint/shared";

/** The repeater scope a stamped template body renders within. */
export interface LineScopeValue {
  /** The quote line the current stamp binds. */
  line: PublicQuoteLine;
  /** The line's display item number, or null for non-item lines. */
  itemNumber: string | null;
  /** The enclosing SECTION line under section grouping, or null. */
  section: PublicQuoteSectionLine | null;
  /** The current quantity break inside `fp-breaks`, or null outside one. */
  quantityBreak: PublicQuoteQuantityBreak | null;
}

/** Context carrying the current repeater scope; null outside a repeater. */
export const LineScopeContext = createContext<LineScopeValue | null>(null);

/**
 * Returns the enclosing repeater scope, or null outside a repeater.
 * @returns The current line scope, or null
 */
export function useLineScope(): LineScopeValue | null {
  return useContext(LineScopeContext);
}
